const initPackPreselection = () => {
  const otp_radio = document.querySelector("#sub_type_2");
  const subs_radio = document.querySelector("#sub_type_1");
  const pack_radio = document.querySelector(
    ".product__variant-item[data-option-value='2 Pack'] label",
  );

  if (otp_radio && subs_radio && pack_radio) {
    otp_radio.addEventListener("change", () => {
      if (otp_radio.checked) {
        pack_radio.click();
      }
    });
  }
};

export { initPackPreselection };
